<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom">
        <div class="modal inmodal" id="detailModal" tabindex="-1" role="dialog" aria-hidden="true">
            <form #attemptForm="ngForm">
                <div class="modal-dialog modal-xl" style="overflow-y: initial !important">
                    <div class="modal-content animated flipInY">
                        <div class="modal-header">
                            <h4 class="modal-title">Fees Request Details</h4>
                            <button type="button" class="close" data-dismiss="modal" (click)="closeForm()"><span
                                    aria-hidden="true">&times;</span>
                                <span class="sr-only">Close</span></button>
                        </div>
                        <div class="modal-body modal_box" style="height: 80vh;overflow-y: auto;">
                            <div class="row">
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label "><b>Academic year</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #AcademicYearID="ngModel" ngModel disabled
                                            name="AcademicYearID" id="AcademicYearID" [(ngModel)]="data.AcademicYearID"
                                            required>
                                            <option *ngFor="let year of years" [value]="year.value"
                                                [selected]="data.AcademicYearID == year.value">
                                                {{ year.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label "><b>Medium</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #MediumID="ngModel" ngModel name="MediumID"
                                            id="MediumID" disabled [(ngModel)]="data.MediumID" required>
                                            <option *ngFor="let medium of mediums" [value]="medium.value"
                                                [selected]="data.MediumID == medium.value">
                                                {{ medium.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label "><b>Course</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #CourseID="ngModel" ngModel name="CourseID"
                                            id="CourseID" disabled (change)="fillCourseYear(0)"
                                            [(ngModel)]="data.CourseID" required>
                                            <option *ngFor="let std of stds" [value]="std.value"
                                                [selected]="data.CourseID == std.value">
                                                {{ std.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label class="form-label "><b>Course Year</b><span class="text-danger">
                                                *</span></label>
                                        <select class="form-control" #CourseYearID="ngModel" ngModel name="CourseYearID"
                                            disabled id="CourseYearID" [(ngModel)]="data.CourseYearID" required>
                                            <option selected value="0"> Select </option>
                                            <option *ngFor="let std of courseyears" [value]="std.value"
                                                [selected]="data.CourseYearID == std.value">
                                                {{ std.text }}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <table id="example" class="table table-striped table-bordered" style="width:100%">
                                        <thead>
                                            <tr>
                                                <th class="pointer" scope="col">Sr. No.</th>
                                                <th class="pointer" scope="col"> Fees Head </th>
                                                <th class="pointer" scope="col">Fees Amount (Current Amount)</th>
                                                <th class="pointer" scope="col">Updated Amount</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let r of data.feesIncreaseList ;let i = index">
                                                <td>
                                                    {{i+ 1}}
                                                </td>
                                                <td>
                                                    <p>{{r.FeesHead}}</p>
                                                </td>
                                                <td>
                                                    <p>{{r.FeesAmountActual}}</p>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" id="newAmt{{i}}"
                                                        name="newAmt{{i}}" value="{{r.FeesAmount}}" disabled
                                                        (keypress)="onlyDouble($event);" (change)="calculateTotal()" />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colspan="2">Total</td>
                                                <td>{{totalFeesAmount}}</td>
                                                <td>{{newTotalFeesAmount}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <textarea class="form-control" type="text" name="txtRemark"
                                        placeholder="Enter remark" id="txtRemark" ngModel maxlength="300"
                                        autocomplete="off"></textarea>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-success" type="button" style="margin: 5px;"
                                    (click)="Action(1)">Accept</button>
                                <button class="btn btn-danger" type="button" style="margin: 5px;"
                                    (click)="Action(2)">Reject</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="row">
            <div class="col-lg-12 col-md-12 col-12">
                <div class="col-mb-4 py-2" style="text-align: left">
                    <h4> Pending Request List</h4>
                </div>
            </div>
        </div>
        <div class="card row">
            <div class=" col-lg-12 col-md-12 col-12 p-4">
                <div>
                    <div class="row">
                        <div class="col-md-11">
                            <div class="py-3">
                                <input type="text" id="searchtext"
                                    class="form-control bg-white border-0 small"
                                    placeholder="Search for..." [(ngModel)]="searchtext"
                                    aria-label="Search" aria-describedby="basic-addon2"
                                    />
                            </div>
                        </div>
                        <div class="col-md-1">
                            <div class="py-3">
                                <button class="btn btn-success" (click)="getFeesIncreaseList(1);"
                                    style="margin: 5px;">Search</button>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table id="example" class="table table-striped table-bordered" style="width:100%">
                            <thead>
                                <tr>
                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. no.</th>
                                    <th class="pointer" scope="col" (click)="sortBy('SchoolName')"> College name </th>
                                    <th class="pointer" scope="col" (click)="sortBy('CollegeCode')"> College code </th>
                                    <th class="pointer" scope="col" (click)="sortBy('RequestDate')"> Request date </th>
                                    <th class="pointer" scope="col" (click)="sortBy('AcademicYear')"> Academic year </th>
                                    <th class="pointer" scope="col" (click)="sortBy('Medium')"> Medium</th>
                                    <th class="pointer" scope="col" (click)="sortBy('Course')"> Course</th>
                                    <th class="pointer" scope="col" (click)="sortBy('InstituteType')"> Institute Type</th>
                                    <th class="pointer" scope="col" (click)="sortBy('CourseYear')"> Course year </th>
                                    <th class="pointer" scope="col" (click)="sortBy('TotalAmount')"> Total amount </th>
                                    <th class="pointer" scope="col" (click)="sortBy('Remark')">Remark</th>
                                    <th class="pointer" scope="col">Action</th>
                                </tr>
                            </thead>
                            <tbody *ngIf="FeesIncreaseList != undefined && FeesIncreaseList.length > 0">
                                <tr *ngFor="let r of FeesIncreaseList | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalFeesReq};let i = index">
                                    <td>{{r.SrNo}}</td>
                                    <td>
                                        <p>{{r.SchoolName}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.CollegeCode}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.RequestDate}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.AcademicYear}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.Medium}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.Course}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.InstituteType}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.CourseYear}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.TotalAmount}}</p>
                                    </td>
                                    <td>
                                        <p>{{r.Remark}}</p>
                                    </td>
                                    <td style="white-space: nowrap;">
                                        <button type="button" class="btn btn-success rmb_10"
                                            (click)="editRequest(r.HashCode)">View Request</button>
                                    </td>
                                </tr>
                            </tbody>
                            <tbody *ngIf="FeesIncreaseList == undefined || FeesIncreaseList.length == 0">
                                <tr>
                                    <td colspan="12" style="text-align: center;">
                                        No data found
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div *ngIf="FeesIncreaseList != undefined && FeesIncreaseList.length != 0" class="card-footer pb-3 pt-3 " align="center">
                        <pagination-controls (pageChange)="getFeesIncreaseList($event)" responsive="true"
                        maxSize="{{totalPages}}"></pagination-controls>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="pt-3">
        <div class="footer-login custom-footer">
            <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
            <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
        </div>
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>